import React from "react";
import "./style.css";
const Button = props => (
  <button
    onClick={props.onClick}
    className="button__Button"
    style={{
      backgroundColor: props.grey ? "#444445" : `var(--${props.type})`,
      border: props.holo
        ? `solid 2px var(--primary)`
        : props.grey
          ? "solid 2px #444445"
          : `solid 2px var(--${props.type})`,
      color: props.holo ? `var(--primary)` : `var(--WHITE)`,
      borderRadius: props.rectangle ? `10px` : `32px`,
      ...props.style
    }}
  >
    {props.children}
  </button>
);

export default Button;
